import {
    INTERVIEW_SET_TYPES,
    INTERVIEW_SET_CATEGORIES
} from '../constants/interview.constant.js';

(function () {

    function InterviewStatusModalController($scope, modalData, sendNewInterviewInvite, withdrawInterview, amsBus, userPermissions) {

        var _AMSDataManager,
            cardInfo;
        $scope.interviewType = modalData.interviewType;
        $scope.INTERVIEW_SET_TYPES = INTERVIEW_SET_TYPES;
        $scope.INTERVIEW_SET_CATEGORIES = INTERVIEW_SET_CATEGORIES;

        if (amsBus.isAMSInitialized) {
            _AMSDataManager = amsBus._AMSDataManager;
            cardInfo = _AMSDataManager.getCardsFromAppIds([modalData.appId]);
        }

        if (cardInfo && cardInfo[modalData.appId]) {
            var location = cardInfo[modalData.appId].data.location || {};

            $scope.candidate = {
                name: cardInfo[modalData.appId].data.name,
                user_id: cardInfo[modalData.appId].data.id,
                profile_image: {
                    uuid: cardInfo[modalData.appId].data.profileImageUUID
                },
                phone: cardInfo[modalData.appId].data.phone,
                location: location.city
            }
        } else {
            AMSAPI.getApplicants(modalData.jobId, [modalData.appId])
                .then(function (data) {

                    var location = data[0].location.find(function (loc) {
                        return loc.UserLocation.is_primary;
                    }) || data[0].location[0] || {};

                    $scope.candidate = {
                        name: data[0].name,
                        user_id: data[0].candidate_id,
                        profile_image: {
                            uuid: data[0].profile_image_id
                        },
                        phone: data[0].phone,
                        location: location.UserLocation && location.UserLocation.formatted_address
                    };

                    $scope.$digest();
                });
        }

        $scope.editInvite = function () {
            $scope.sendNewInvite(true);
        };

        $scope.sendNewInvite = function (withoutWithdraw) {
            /*
            * Here where the code should be to open the send invite model in the interview status modal.
            * */
            sendNewInterviewInvite(modalData.appId, withoutWithdraw);
            $scope.$hide();
        };

        $scope.withdraw = function () {

            if (!$scope.loading) {

                $scope.loading = true;

                InterviewV2API.withdrawInterview(modalData.brandId, modalData.jobId, [modalData.appId], $scope.interviewType)
                    .then(function (res) {

                        if (res && res.succeded && res.succeded.length && res.succeded.indexOf(parseInt(modalData.appId)) > -1) {
                            withdrawInterview(modalData.appId);
                            $scope.loading = false;
                            $scope.$hide();
                            $scope.$digest();
                        }
                        else {
                            $scope.loading = false;
                            $scope.$digest();
                        }

                    }, function (err) {

                        $scope.loading = false;
                        $scope.$digest();
                    });
            }
        };

        let init = () => {
            userPermissions.getBrandPolicy(modalData.brandId)
                .then((response) => {
                    const policyParser = response;
                    $scope.canManageInterviewTemplates = policyParser.has(userPermissions.PERMISSIONS.MANAGE_VIDEO_INTERVIEW_TEMPLATES);
                    $scope.$digest();
                }).catch((err) => {
                    console.error(err);
                });
        };

        init();

        (function () {
            InterviewV2API.getApplicationStatusDetails(modalData.brandId, modalData.jobId, modalData.appId, $scope.interviewType)
                .then(function (response) {

                    $scope.appDetails = response;
                    $scope.$digest();
                });
        })();

        $scope.INTERVIEW_STATUSES = InterviewV2API.INTERVIEW_STATUSES;
    }

    angular.module("harriApp")
        .controller("InterviewStatusModalController", [
            '$scope',
            'modalData',
            'sendNewInterviewInvite',
            'withdrawInterview',
            'amsBus',
            'userPermissions',
            InterviewStatusModalController
        ]);
})();